import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import queryString from "query-string";

import moment from "moment";
import Filters from "./Filters";
import ReportService from "../../../services/reportService";
import { formatDate } from "../../../helpers/date";

import { CUSTOMER_ANNUAL_REVENUE_ANALYSIS_COLUMNS } from "./columns";

import { downloadCSV } from "../utils";

import CustomerAnnualRevenueAnalysisList from "./CustomerAnnualRevenueAnalysisList";

import "./CustomerAnnualRevenueAnalysis.scss";

const CustomerAnnualRevenueAnalysisPage = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    call_type: null,
    start_date: formatDate(
      new Date(`1/1/${new Date().getFullYear()}`),
      "yyyy-MM-dd"
    ),
    end_date: formatDate(new Date(), "yyyy-MM-dd")
  });
  const [data, setData] = useState([]);
  const [years, setYears] = useState([new Date().getFullYear()]);

  const fetchData = useCallback(async () => {
    setLoading(true);
    let query = {
      groupByField: "customer"
    };
    if (filters.call_type && filters.call_type.length) {
      query.call_type = filters.call_type.map(({ value }) => value);
    }
    if (filters.start_date) {
      query.start_date = filters.start_date;
    }

    if (filters.end_date) {
      query.end_date = filters.end_date;
    }
    query = queryString.stringify(query, { arrayFormat: "bracket" });
    const result = await ReportService.get(
      `/customer-annual-revenue-analysis?${query}`
    );
    setData(result);
    setLoading(false);
  }, [filters, setData, setLoading]);

  const handleChange = (name) => (value) => {
    setLoading(false);
    setFilters({ ...filters, [name]: value });
    if (name.includes("_date")) {
      const year = new Date(value).getFullYear();
      if (year && !years.includes(year)) {
        setYears([...years, year]);
      }
    }
  };

  const handleRowClick = (rowInfo) => {
    history.push(`/app/contracts/${rowInfo.original._id}`);
  };

  const handleResetClick = () => {
    setFilters({
      call_type: null,
      start_date: formatDate(
        new Date(`1/1/${new Date().getFullYear()}`),
        "yyyy-MM-dd"
      ),
      end_date: formatDate(new Date(), "yyyy-MM-dd")
    });
    setData([]);
  };

  const handleExport = () => {
    const title = `Customer Annual Revenue from ${moment(
      filters.start_date
    ).format("MM/DD/YYYY")} to ${moment(filters.end_date).format(
      "MM/DD/YYYY"
    )}`;

    downloadCSV(
      `CustomerAnnualRevenue-${formatDate(new Date(), "yyyyMMdd")}`,
      data,
      CUSTOMER_ANNUAL_REVENUE_ANALYSIS_COLUMNS(years, true),
      title
    );
  };

  return (
    <div id="customer-collection-page" className="report-page">
      <Filters
        filters={filters}
        onChange={handleChange}
        onFetchClick={fetchData}
        onResetClick={handleResetClick}
        loading={loading}
        onCSVExport={handleExport}
        exportDisabled={!data.length}
      />
      <CustomerAnnualRevenueAnalysisList
        data={data}
        loading={loading}
        onRowClick={handleRowClick}
        years={years}
      />
    </div>
  );
};

CustomerAnnualRevenueAnalysisPage.propTypes = {
  history: PropTypes.object
};

export default CustomerAnnualRevenueAnalysisPage;
